module.exports = __webpack_public_path__ + "static/media/bi.099dc29c.jpeg";